export default __webpack_public_path__ + "static/2-89bdb76d71ac0339b87a622b6b2149ef.jpeg";